class RadioButtons
{
    constructor(elements, taxonomyName, value = null) {
        this.elements = elements;
        this.taxonomyName = taxonomyName;
        this.value = value;
    }

    watchValue(callback)
    {
        for (let element of this.elements) {
            element.addEventListener("click", (e) => {
                this.setValue(e.target.value);
                callback(this.value);
            });
        }
    }

    setValue(value)
    {
        console.log("RadioButtons.js - Setting value on " + this.taxonomyName + " Value: ", value);
        console.log("RadioButtons.js - This: ", this);
        this.value = value ?? null;
    }

    getValue()
    {
        return this.value;
    }
}

export default RadioButtons;
